import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateContactMutation as CreateContactMutationType,
  CreateContactMutationVariables,
} from "./__generated__/CreateContactMutation";

const CreateContactMutation = loader("./CreateContactMutation.gql");

type CreateContactMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateContactMutationType) => void;
}) => ReactElement;

export const CreateContactMutationProvider: CreateContactMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateContactMutationType, CreateContactMutationVariables>(
    CreateContactMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
      refetchQueries: ["GetContextQuery"],
      awaitRefetchQueries: true,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
